export default __webpack_public_path__ + "images/customer-happy8761fa0d33bb5c1f70eb3dad72a06528.svg";